import { render } from "./ContactUS.vue?vue&type=template&id=68994fb2"
import script from "./ContactUS.vue?vue&type=script&lang=js"
export * from "./ContactUS.vue?vue&type=script&lang=js"

import "./ContactUS.vue?vue&type=style&index=0&id=68994fb2&lang=less"

import exportComponent from "/Users/longliu/Desktop/projects/povertyalleviation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__